import styled from "@emotion/styled"
import {
  Switch as DefaultSwitch,
  SwitchProps as DefaultSwitchProps
} from "@chakra-ui/react"
import { PlansPageStyling } from "src/context/types"

export const Switch = styled(DefaultSwitch)<
  DefaultSwitchProps & { styles: PlansPageStyling }
>`
  .chakra-switch__track {
    background: ${({ isChecked, styles }) =>
      isChecked ? styles?.planPagePanelTextColor ?? "#A0AEC0" : "#CBD0E0"};
    &[data-focus] {
      box-shadow: none;
    }
  }
  .chakra-switch__thumb {
    background: ${({ styles }) => styles?.planPageButtonBackgroundColor};
  }
`
